import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Organization } from '@/models/organization.model';

class OrganizationService extends BaseService {
  private url: string = '/api/organization';

  constructor() {
    super();
  }

  public async getAll(): Promise<DataResponse<Organization[]>> {
    const res = await this.$http.get<Organization[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    data: Partial<Organization>,
  ): Promise<DataResponse<Organization>> {
    const res = await this.$http.post<Organization>(this.url, data);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
      message: res.message,
    };
  }

  public async edit(data: Organization): Promise<DataResponse<Organization>> {
    const res = await this.$http.put<Organization>(
      `${this.url}/${data.id}`,
      data,
    );

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
      message: res.message,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }

  public async removeUser(
    id: number,
    userId: number,
  ): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(
      `${this.url}/${id}/user/${userId}`,
    );

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new OrganizationService();
